export default __webpack_public_path__ + "static/media/icon-grid-view-default.46116efe.svg";